var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"hero is-medium is-warning"},[_c('div',{staticClass:"hero-body"},[_c('p',{staticClass:"title"},[_vm._v(" Your document signing process is completed. ")]),_c('p',{staticClass:"subtitle"},[_vm._v(" Thank you. ")])])])])
}]

export { render, staticRenderFns }